import {getResultInfo} from '@web/actions/result'
import makeSlice from '@web/slices/recommendationProduct/sliceMaker'

const recommendationProductSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getResultInfo.fulfilled, (state, {payload: {products}}) => {
            state.products = products.map((product) => {
                return {
                    ecNvMid: product.ecNvMid ?? undefined,
                    orderDateTime: product.orderDateTime ?? undefined,
                    productOrderStatus: product.productOrderStatus ?? undefined,
                    productPaymentAmount: product.productPaymentAmount ?? undefined,
                    productCategoryId: product.productCategoryId ?? undefined,
                }
            })
        })
    },
})

export default recommendationProductSlice.reducer
